/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from 'dayjs';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import creditAgricole from "../../../assets/images/banques/credit_agricole.png";
import caisseEpargne from "../../../assets/images/banques/caisse_epargne.png";
import banquePopulaire from "../../../assets/images/banques/banque_populaire.png";
import boursorama from "../../../assets/images/banques/boursorama.png";
import lcl from "../../../assets/images/banques/lcl.png";
import bnpParibas from "../../../assets/images/banques/bnp_paribas.png";
import banquePostale from "../../../assets/images/banques/banque_postale.png";
import societeGenerale from "../../../assets/images/banques/societe_generale.png";
import creditMutuel from "../../../assets/images/banques/credit_mutuel.png";
import cic from "../../../assets/images/banques/cic.png";
import hsbc from "../../../assets/images/banques/hsbc.png";
import fortuneo from "../../../assets/images/banques/fortuneo.png";
import arkea from "../../../assets/images/banques/arkea.png";
import creditDuNord from "../../../assets/images/banques/credit_du_nord.png";
import creditFoncier from "../../../assets/images/banques/credit_foncier.png";
import ing from "../../../assets/images/banques/ing.png";
import axa from "../../../assets/images/banques/axa.png";
import bred from "../../../assets/images/banques/bred.png";
import bForBank from "../../../assets/images/banques/b_for_bank.png";
import orangeBank from "../../../assets/images/banques/orange_bank.png";
import banqueMutualiste from "../../../assets/images/banques/banque_française_mutualiste.png";
import creditImmobilier from "../../../assets/images/banques/credit_immobilier.png";
import banquePlatine from "../../../assets/images/banques/banque_platine.png";
import cetelem from "../../../assets/images/banques/cetelem.png";
import federalFinance from "../../../assets/images/banques/federal_finance.png";
import { useDispatch, useSelector } from 'react-redux';
import Question from '../../Question/Question';
import { Backdrop, Badge, Box, Button, Fade, FormControl, Grid, Grow, InputAdornment, MenuItem, Modal, OutlinedInput, Select, Stack, TextField } from '@mui/material';
import { HiUser, HiUsers, HiUserGroup } from "react-icons/hi2";
import { BiSolidBank } from "react-icons/bi";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoIosAdd } from "react-icons/io";
import { IoBarChartSharp } from "react-icons/io5";
import { RiEditBoxLine } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";
import Label from '../../Label/Label';
import Error from '../../Error/Error';
import colors from '../../../colors/colors';
import { DatePicker } from '@mui/x-date-pickers';
import { GoCheckCircleFill } from 'react-icons/go';
import { changeCurrentErrorMessage, changeIsButtonEnabled, changeStepsDataEmprunteur } from '../../../redux/actions';
import '../ParcoursEmprunteur.scss';


const banques = [
    { name: "Crédit Agricole", image: creditAgricole },
    { name: "Caisse d'Epargne", image: caisseEpargne },
    { name: "Banque Populaire", image: banquePopulaire },
    { name: "Boursorama", image: boursorama },
    { name: "LCL", image: lcl },
    { name: "BNP Paribas", image: bnpParibas },
    { name: "La banque Postale", image: banquePostale },
    { name: "Société Générale", image: societeGenerale },
    { name: "Crédit Mutuel", image: creditMutuel },
    { name: "CIC", image: cic },
    { name: "HSBC", image: hsbc },
    { name: "Fortuneo", image: fortuneo },
    { name: "Crédit Mutuel Arkea", image: arkea },
    { name: "Crédit du Nord", image: creditDuNord },
    { name: "Crédit Foncier", image: creditFoncier },
    { name: "ING", image: ing },
    { name: "AXA Banque", image: axa },
    { name: "BRED Banque Populaire", image: bred },
    { name: "BforBANK", image: bForBank },
    { name: "Orange Bank", image: orangeBank },
    { name: "Banque Française Mutualiste", image: banqueMutualiste },
    { name: "Crédit Immobilier de France", image: creditImmobilier },
    { name: "Banque Palatine", image: banquePlatine },
    { name: "Cetelem", image: cetelem },
    { name: "Federal Finance", image: federalFinance },
];

const questions = [
    <Fragment>
        <p style={{ fontSize: 16 }}>
            Auprès de quelle banque avez-vous souscrit ce prêt immobilier ?
            Il est vraiment important que vous répondiez correctement à cette question car <span className='p-bold' style={{ fontSize: 16 }}>les exigences en matière de garanties changent</span> d'une banque à l'autre.
        </p>
    </Fragment>,
    <Fragment>
        <p style={{ fontSize: 16 }}>
            À présent détaillons ensemble le prêt que vous souhaitez assurer. <br />
            Le montant du prêt doit être compris entre <span className='p-bold' style={{ fontSize: 16 }}> 17 000 € et 5 000 000 € </span>
            , la durée du prêt doit être comprise entre <span className='p-bold' style={{ fontSize: 16 }}> 12 et 420 mois </span>
        </p>
    </Fragment>,
    <Fragment> <p style={{ fontSize: 16 }} >Combien de personnes voulez-vous assurer ?</p></Fragment>
];

const nbrPersons = [
    { title: "Une seule personne", icon: <HiUser style={{ fontSize: 70, color: colors.blue1 }} /> },
    { title: "Vous et votre co-emprunteur", icon: <HiUsers style={{ fontSize: 70, color: colors.blue1 }} /> },
    { title: "Plus de deux personnes", icon: <HiUserGroup style={{ fontSize: 70, color: colors.blue1 }} /> }
];

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 2,
    p: 6,
    outline: "none !important"
};

const replaceNullWithEmptyString = (obj: any) => {
    for (let key in obj) {
        if (obj[key] === null) {
            obj[key] = "";
        }
    }
    return obj;
};


export default function InfosPret(props: any) {
    const dispatch = useDispatch();
    const stepEmprunteur = useSelector((store: any) => store.stepEmprunteur.stepEmprunteur);
    const currentSubstep = useSelector((store: any) => store.currentSubstep.currentSubstep);
    const initDataEmprunteur = useSelector((store: any) => store.initDataEmprunteur.initDataEmprunteur);
    const stepsDataEmprunteur = useSelector((store: any) => store.stepsDataEmprunteur.stepsDataEmprunteur);
    const currentErreurMessage = useSelector((store: any) => store.currentErreurMessage.currentErreurMessage);

    const [data, setData] = useState<any>(stepsDataEmprunteur["informations-pret"]);
    const [dataPret, setDataPret] = useState<any>(stepsDataEmprunteur["informations-pret"]["prets"]);
    const [dataOrganisme, setDataOrganisme] = useState<any>(
        replaceNullWithEmptyString(stepsDataEmprunteur["informations-pret"]["organisme"]));
    const [lstPays] = useState<any>(initDataEmprunteur["lst_pays"]);

    const [open, setOpen] = useState(false);
    const [activePret, setActivePret] = useState<number>(0);
    const [selectedNumber, setSelectedNumber] = useState<number | null>(stepsDataEmprunteur["informations-pret"]["nb_adherents"]);
    const [showEmprunteurList, setShowEmprunteurList] = useState(false);


    useEffect(() => {
        window.scroll(0, 0);
        dispatch(changeIsButtonEnabled(false));
        if (stepsDataEmprunteur["informations-pret"]["nb_adherents"] > 2) {
            setSelectedNumber(3);
            setShowEmprunteurList(true);
        }
        return () => {
            dispatch(changeCurrentErrorMessage(currentErreurMessage ?? null));
            dispatch(changeIsButtonEnabled(false));
        }
    }, []);

    useEffect(() => {
        dispatch(changeStepsDataEmprunteur({ ...stepsDataEmprunteur, "informations-pret": data }));
        if (isStepDataValid()) {
            dispatch(changeIsButtonEnabled(true));
        } else {
            dispatch(changeIsButtonEnabled(false));
        }
    }, [data]);

    useEffect(() => {
        setData((prevState: any) => ({ ...prevState, organisme: dataOrganisme }));
    }, [dataOrganisme]);

    useEffect(() => {
        setData((prevState: any) => ({ ...prevState, prets: dataPret }));
    }, [dataPret]);

    useEffect(() => {
        if (isStepDataValid()) {
            dispatch(changeIsButtonEnabled(true));
        } else {
            dispatch(changeIsButtonEnabled(false));
        }
    }, [currentSubstep]);


    const setStepData = (key: string, value: any) => {
        setData((prevState: any) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const handleDataOrganisme = (key: string, value: any) => {
        setDataOrganisme((prevState: any) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const handleDataPret = (index: number, key: string, value: any) => {
        setDataPret((prevState: any) => prevState.map((obj: any, i: number) => {
            if (i === index) {
                return {
                    ...obj,
                    [key]: value
                };
            }
            return obj;
        }));
    };

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const isOtherBank = () => dataOrganisme["nom"] && !banques.some(banque => banque.name === dataOrganisme["nom"]);

    const addNewPret = () => {
        const newPret = {
            montant_pret: "",
            taux_pret: "",
            date_premiere_echeance: "",
            duree_pret: "",
            type_pret: "Amortissable",
            ugip_amortissement: "Mensuel"
        };
        setDataPret((prevState: any) => {
            const updatedDataPret = [...prevState, newPret];
            setActivePret(updatedDataPret.length - 1);
            return updatedDataPret;
        });
    };

    const removePret = (index: number, key: string, value: boolean) => {
        setDataPret((prevState: any) => {
            return prevState.map((obj: any, i: number) => {
                if (i === index) {
                    return {
                        ...obj,
                        [key]: value
                    };
                }
                return obj;
            }).filter((pret: any) => pret.montant_pret !== "");
        });
    };

    const handleSelectEmprunteur = (index: number) => {
        // Plus de deux adhérents
        if (index === 3) {
            setSelectedNumber(index);
            setShowEmprunteurList(true);
        }
        else {
            setShowEmprunteurList(false);
            setStepData("nb_adherents", index);
            setSelectedNumber(index);
        }
    };

    const handleNumberPersonne = (index: number) => {
        setStepData("nb_adherents", index);
    };

    const isStepDataValid = () => {
        if (currentSubstep === 0) {
            return (
                dataOrganisme["nom"] && dataOrganisme["nom"] !== "" &&
                dataOrganisme["pays"] && dataOrganisme["pays"] !== ""
            );
        }
        if (currentSubstep === 1) {
            return (
                dataPret.filter((pret: any) => !pret.hasOwnProperty('is_deletable')).length > 0 &&
                dataPret.every((pret: any) => {
                    return (
                        pret["date_premiere_echeance"] !== "" && pret["taux_pret"] !== "" && parseFloat(pret["taux_pret"]) > 0 &&
                        pret["montant_pret"] !== "" && parseInt(pret["montant_pret"]) >= 17000 && parseInt(pret["montant_pret"]) <= 5000000 &&
                        pret["duree_pret"] !== "" && parseInt(pret["duree_pret"]) >= 12 && parseInt(pret["duree_pret"]) <= 420 &&
                        pret["type_pret"] !== "" && pret["ugip_amortissement"] !== ""
                    )
                })
            );
        }
        if (currentSubstep === 2) {
            return typeof data["nb_adherents"] === "number";
        }
    };


    return (
        <Stack spacing={2} mt={6}>
            {currentErreurMessage && (<Error error={currentErreurMessage} />)}
            {((): any => {
                if (currentSubstep === 0) {
                    return (
                        <Fade in={stepEmprunteur === 1} {...({ timeout: 1500 })}>
                            <Stack>
                                <Question question={questions[currentSubstep]} />
                                <Grid container spacing={2} mt={2}>
                                    {
                                        banques?.map((bk: any, index: number) => (
                                            <Grid container item md={3} xs={6} key={index} onClick={() => handleDataOrganisme("nom", bk.name)}>
                                                <Stack width={"100%"} className={`type-select-bank ${dataOrganisme["nom"] === bk.name ? "box-border" : ""}`} borderRadius={2}>
                                                    <Badge
                                                        overlap="circular"
                                                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                        badgeContent={
                                                            <GoCheckCircleFill style={{ fontSize: 25, color: colors.blue1, opacity: dataOrganisme["nom"] === bk.name ? 1 : 0 }} />
                                                        }
                                                    >
                                                        <Stack direction={"column"} alignItems={"center"} justifyContent={"center"} width={"100%"} py={1.5}>
                                                            <Box component="img" src={bk.image} alt={bk.name} width={150} />
                                                        </Stack>
                                                    </Badge>
                                                </Stack>
                                            </Grid>
                                        ))
                                    }
                                    <Grid container item md={3} xs={6} onClick={handleOpen}>
                                        <Stack width={"100%"} className={`type-select-bank ${isOtherBank() ? "box-border" : ""}`} borderRadius={2} justifyContent={"center"}>
                                            <Badge
                                                overlap="circular"
                                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                badgeContent={
                                                    <GoCheckCircleFill style={{ fontSize: 25, color: colors.blue1, opacity: isOtherBank() ? 1 : 0 }} />
                                                }
                                            >
                                                <Stack direction={"column"} alignItems={"center"} justifyContent={"center"} width={"100%"} py={1.5}>
                                                    <Box component="p">
                                                        <span className='century-bold' style={{ fontSize: 15 }}>Autre banque</span>
                                                    </Box>
                                                </Stack>
                                            </Badge>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Stack>
                        </Fade>
                    )
                }
                if (currentSubstep === 1) {
                    return (
                        <Grow in={stepEmprunteur === 1} {...({ timeout: 1000 })}>
                            <Stack>
                                <Question question={questions[currentSubstep]} />
                                {
                                    dataPret?.map((pret: any, index: number) => (
                                        !pret.hasOwnProperty('is_deletable') && (
                                            activePret === index ? (
                                                <Stack width={"100%"} className='form-section' mt={3} key={index}>
                                                    <Stack p={5} spacing={2}>
                                                        <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                                            <FormControl fullWidth required>
                                                                <Label label={"Montant initial"} />
                                                                <OutlinedInput placeholder="200 000" endAdornment={<InputAdornment position="end">€</InputAdornment>} onChange={(event: any) => handleDataPret(index, "montant_pret", event.target.value)} value={dataPret[index]["montant_pret"] ?? ""} />
                                                            </FormControl>
                                                            <FormControl fullWidth required>
                                                                <Label label={"Taux"} />
                                                                <OutlinedInput placeholder='1,00' type="number" endAdornment={<InputAdornment position="end">%</InputAdornment>} onChange={(event: any) => handleDataPret(index, "taux_pret", event.target.value)} value={dataPret[index]["taux_pret"] ?? ""} />
                                                            </FormControl>
                                                        </Stack>
                                                        <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                                            <FormControl fullWidth required>
                                                                <Label label={"Première échéance"} />
                                                                <DatePicker value={dayjs(dataPret[index]["date_premiere_echeance"]) ?? ""}
                                                                    onChange={(value: any) => handleDataPret(index, "date_premiere_echeance", moment(value.toString()).format("YYYY-MM-DD"))}
                                                                />
                                                            </FormControl>
                                                            <FormControl fullWidth required>
                                                                <Label label={"Durée totale"} />
                                                                <OutlinedInput placeholder='240' endAdornment={<InputAdornment position="end">mois</InputAdornment>} onChange={(event: any) => handleDataPret(index, "duree_pret", event.target.value)} value={dataPret[index]["duree_pret"] ?? ""} />
                                                            </FormControl>
                                                        </Stack>
                                                        <Stack direction={"row"} alignItems={"center"} bgcolor={"#eae9e3"} p={2} spacing={2} borderRadius={2}>
                                                            <AiOutlineInfoCircle style={{ fontSize: 40, color: "#706b56" }} />
                                                            <small className='century' style={{ color: "#706b56" }}>
                                                                Si vous ne disposez pas des informations exactes, ne vous inquiétez pas !
                                                                Vous pouvez renseigner des valeurs approximatives et nos experts les corrigeront avec vous si nécessaire.
                                                            </small>
                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            ) : (
                                                <Stack width={"100%"} className='form-section' mt={3} key={index}>
                                                    <Stack p={4}>
                                                        <Stack direction={"row"} alignItems={"center"} spacing={1} justifyContent={"space-between"}>
                                                            <Stack direction={"row"} alignItems={"center"} spacing={2}>
                                                                <IoBarChartSharp style={{ fontSize: 20, color: colors.blue1 }} />
                                                                <Stack gap={1}>
                                                                    <h4 className='m-0' style={{ fontSize: 20 }}>{dataPret[index]["montant_pret"]} €</h4>
                                                                    <small>{dataPret[index]["taux_pret"]} % . {dataPret[index]["duree_pret"]} mois</small>
                                                                </Stack>
                                                            </Stack>
                                                            <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                                                <RiEditBoxLine className='cursor-pointer' onClick={() => setActivePret(index)} style={{ fontSize: 30, color: "#aaa8a1" }} />
                                                                <AiOutlineClose className='cursor-pointer' onClick={() => removePret(index, "is_deletable", true)} style={{ fontSize: 30, color: "#aaa8a1" }} />
                                                            </Stack>
                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            )
                                        ))
                                    )

                                }
                                {
                                    dataPret.length < 6 && (
                                        <Stack width={"100%"} className='form-section cursor-pointer' mt={3} onClick={addNewPret}>
                                            <Stack p={2.5} spacing={2}>
                                                <Stack direction={"row"} alignItems={"center"} spacing={1} >
                                                    <IoIosAdd style={{ fontSize: 40, color: colors.blue1 }} />
                                                    <p>Renseigner un autre prêt</p>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    )
                                }
                            </Stack>
                        </Grow>
                    )
                }
                if (currentSubstep === 2) {
                    return (
                        <Fade in={stepEmprunteur === 1} {...({ timeout: 1500 })}>
                            <Stack>
                                <Question question={questions[currentSubstep]} />
                                <Grid container spacing={2} mt={2}>
                                    {
                                        nbrPersons?.map((pers: any, index: number) => (
                                            <Grid container item md={4} xs={6} key={index} onClick={() => handleSelectEmprunteur(index + 1)}>
                                                <Stack width={"100%"} className={`type-select ${selectedNumber === index + 1 ? "box-border" : ""}`} borderRadius={2}>
                                                    <Badge
                                                        overlap="circular"
                                                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                        badgeContent={
                                                            <GoCheckCircleFill style={{ fontSize: 25, color: colors.blue1, opacity: selectedNumber === index + 1 ? 1 : 0 }} />
                                                        }
                                                    >
                                                        <Stack direction={"column"} p={4} py={6} alignItems={"center"} justifyContent={"center"} width={"100%"}>
                                                            {pers.icon}
                                                            <p className='m-0 text-center' style={{ fontSize: 15 }}>{pers.title}</p>
                                                        </Stack>
                                                    </Badge>
                                                </Stack>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                                {
                                    showEmprunteurList && (
                                        <Fade in={showEmprunteurList} {...({ timeout: 1500 })}>
                                            <Stack mt={3}>
                                                <p style={{ fontSize: 16 }} >Choisissez le nombre exact de personnes</p>
                                                <Grid container spacing={2} mt={2}>
                                                    {
                                                        Array.from({ length: 2 }, (_, index) => (
                                                            <Grid container item md={3} xs={6} key={index} onClick={() => handleNumberPersonne(index + 3)}>
                                                                <Stack width={"100%"} className={`type-select ${data["nb_adherents"] === index + 3 ? "box-border" : ""}`} borderRadius={2}>
                                                                    <Badge
                                                                        overlap="circular"
                                                                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                        badgeContent={
                                                                            <GoCheckCircleFill style={{ fontSize: 25, color: colors.blue1, opacity: data["nb_adherents"] === index + 3 ? 1 : 0 }} />
                                                                        }
                                                                    >
                                                                        <Stack direction={"column"} p={4} alignItems={"center"} justifyContent={"center"} width={"100%"}>
                                                                            <h2 className='m-0 text-center text-blue-1'>{index + 3}</h2>
                                                                        </Stack>
                                                                    </Badge>
                                                                </Stack>
                                                            </Grid>
                                                        ))
                                                    }
                                                </Grid>
                                            </Stack>
                                        </Fade>
                                    )
                                }
                            </Stack>
                        </Fade>
                    )
                }
            })()}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 1000,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style} width={{ md: 400, xs: "unset" }}>
                        <Stack width={"100%"} justifyContent={"center"} alignItems={"center"}>
                            <BiSolidBank style={{ fontSize: 70, color: colors.blue1 }} />
                            <p className="text-bold m-0" >Autre banque</p>
                        </Stack>
                        <Stack spacing={2} mt={4}>
                            <FormControl fullWidth required>
                                <Label label={"Nom de la banque"} />
                                <TextField onChange={(event: any) => handleDataOrganisme("nom", event.target.value)} variant="outlined" value={isOtherBank() ? dataOrganisme["nom"] : ""} />
                            </FormControl>
                            <FormControl fullWidth required>
                                <Label label={"Pays"} />
                                <Select
                                    labelId="demo-simple-select-label"
                                    onChange={(event: any) => handleDataOrganisme("pays", event.target.value)}
                                    input={<OutlinedInput value={dataOrganisme["pays"]} />}
                                >
                                    {
                                        lstPays?.map((pn: any, index: number) => (
                                            <MenuItem value={pn} key={index}>{pn}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Button className="btn-precedent" onClick={handleClose} variant="text">
                                    Annuler
                                </Button>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button className={"btn-suivant"} variant="contained" onClick={() => { handleClose(); props.goNext() }}>
                                    Valider
                                </Button>
                            </Box>
                        </Stack>
                    </Box>
                </Fade>
            </Modal>
        </Stack>
    )
};